import { render, staticRenderFns } from "./hotSale.vue?vue&type=template&id=6b48d2a6&scoped=true"
import script from "./hotSale.vue?vue&type=script&lang=js"
export * from "./hotSale.vue?vue&type=script&lang=js"
import style0 from "./hotSale.vue?vue&type=style&index=0&id=6b48d2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48d2a6",
  null
  
)

export default component.exports